<template>
  <div>
    <section-wrapper>
      <div class="olympic active">
        <section class="olympic__header">
          <div class="olympic__header__text">
            <h1 class="text-danger">ПРОГРАММА ДПО</h1>
            <h1 class="mt-2 content_60">«КАДРЫ ДЛЯ ЭКСПОРТА:</h1>
            <h1 class="mt-2 content_60">ОТ ТЕОРИИ К ПРАКТИКЕ»</h1>
            <h2 class="mt-2 text-primary">Полностью в онлайн-формате</h2>
            <p class="mt-2 content_22">Освойте все этапы экспорта — от идеи до поставки</p>
            <p class="mt-2 content_22">Получите диплом профессиональной переподготовки и создайте реальный экспортный проект под руководством топ-экспертов Школы экспорта РЭЦ</p>
          </div>
          <div class="d-none d-lg-block olympic__header__img">
            <img title="ОБРАЗОВАТЕЛЬНАЯ ПРОГРАММА" src="/pic/owl.png" />
          </div>
        </section>

        <section class="olympic__text mb-5">
          <p class="content_22 mt-2"><span class="text-danger"><b>Период обучения: 31 октября 2025 - 30 декабря 2025</b></span></p>
          <p class="content_22 mt-2">Ближайший поток программы реализуется с октября по декабрь и включает 3 модуля общей продолжительностью 9 недель:</p>
          <ul class="content_22 mb-2">
            <li>1 модуль – до 2-х недель</li>
            <li>2 модуль – до 5-ти недель</li>
            <li>3 модуль – до 2-х недель</li>
          </ul>
          <p class="content_22 mt-2"><span class="text-danger"><b>Итоговая аттестация: декабрь.</b></span></p>
          <p class="content_22 mt-2">Диплом выдается при успешном прохождении всех этапов программы и защите итогового проекта.</p>
          <p class="content_22 mt-2"><span class="text-danger"><b>Если вы ещё учитесь:</b></span> диплом о профессиональной переподготовке будет выдан после предоставления документа о высшем или среднем профессиональном образовании (диплом ВО/СПО).</p>
          <div class="mt-4">
            <link-target link="/events/5748" class="mt-1">
              Подать заявку на программу
            </link-target>
          </div>
        </section>

        <section class="olympic__text mb-5">
          <h1 class="text-dark mb-2">Стоимость программы:</h1>
          <p class="content_22 mt-2">
            Программа доступна по двум тарифам:
          </p>
          <ul class="content_22 mb-2">
            <li>Для специалистов — <span class="text-danger"><b>50 000 рублей</b></span></li>
            <li>Для студентов (при предъявлении подтверждающего статус документа) — <span class="text-danger"><b>25 000 рублей</b></span> (скидка 50%)</li>
          </ul>
        </section>

        <!-- Содержание программы -->
        <section class="olympic__text mb-5">
          <h1 class="text-dark mb-2">Содержание программы:</h1>
          <schedule 
            :steps="programSteps"
          />
        </section>

        <!-- Почему выбирают нашу программу -->
        <section class="olympic__text mb-5">
          <h1 class="text-dark mb-2">Почему выбирают нашу программу?</h1>
          <ul class="content_22 mb-2">
            <li>Диплом установленного образца для работы в сфере ВЭД</li>
            <li>80% практики — вы разработаете настоящий экспортный проект</li>
            <li>Наставники – федеральные эксперты Школы экспорта РЭЦ</li>
            <li>Ключевые аспекты: ИНКОТЕРМС, документооборот, маркетинг, таможня, логистика</li>
            <li>100% онлайн — учиться можно из любой точки мира</li>
            <li>Гибкий график — совмещайте с работой или учёбой</li>
          </ul>
        </section>

        <!-- Кто преподает -->
        <section class="olympic__text mb-5">
          <h1 class="text-dark mb-2">Кто преподает?</h1>
          <p class="content_22 mt-2">
            Обучение ведут сертифицированные федеральные тренеры Школы экспорта РЭЦ с многолетним опытом в сопровождении экспорта, логистике, праве и маркетинге.
          </p>
        </section>

        <!-- Чему вы научитесь -->
        <section class="olympic__text mb-5">
          <h1 class="text-dark mb-2">Чему вы научитесь?</h1>
          <h3 class="content_22 mt-2"><b>Жизненный цикл экспортного проекта:</b></h3>
          <ul class="content_22 mb-2">
            <li>Анализ рынков и выбор ниши</li>
            <li>Адаптация продукта под требования страны назначения</li>
            <li>Документооборот: инвойсы, коносаменты, сертификаты</li>
            <li>Таможенное оформление и работа с ТН ВЭД</li>
            <li>Логистика: морские, авиа-, ж/д и автомобильные перевозки</li>
            <li>Формы расчётов и валютный контроль</li>
            <li>Экспортный маркетинг и продвижение за рубежом</li>
            <li>Деловая коммуникация с иностранными партнёрами</li>
            <li>Применение ИИ в анализе спроса и автоматизации процессов</li>
          </ul>
          <div class="row align-items-center mb-4">
            <div class="col-lg-7">
              <p class="content_22 mb-2"><b>Итоговый проект:</b> вы разработаете реальный экспортный проект на базе действующего предприятия. Получите обратную связь от экспертов РЭЦ и сможете добавить его в своё портфолио.</p>
              <p class="content_22 mb-2">
                По итогу обучения вы получите диплом профессиональной переподготовки установленного образца с правом ведения профессиональной деятельности в сфере ВЭД
              </p>
              <p class="content_22 mb-2">
                Государственная лицензия от 19.11.2018 № Л035-01298-77/00183332, выданная Департаментом образования города Москвы
              </p>
            </div>
            <div class="col-lg-5 text-center">
              <img src="/pic/diploma.png" alt="Диплом" class="img-fluid" style="max-width: 100%;" />
            </div>
          </div>
        </section>

        <!-- Для кого эта программа -->
        <section class="olympic__text mb-5">
          <h1 class="text-dark mb-2">Для кого эта программа?</h1>
          <ul class="content_22 mb-2">
            <li>Вы — специалист, хотите систематизировать знания и получить диплом для карьеры в ВЭД</li>
            <li>Вы — студент выпускного курса, хотите добавить в портфолио практический проект</li>
            <li>Вы — предприниматель, планируете вывести бизнес на международные рынки</li>
            <li>Вы — новичок в экспорте, но хотите войти в профессию с сильной базой</li>
          </ul>
        </section>

        <!-- Какие документы нужны -->
        <section class="olympic__text mb-5">
          <h1 class="text-dark mb-2">Какие документы нужны</h1>
          <p class="content_22 mt-2">При подаче заявки на обучение необходимо прикрепить:</p>
          <ul class="content_22 mb-2">
            <li>Скан паспорта (страница с фото и регистрацией)</li>
            <li>Диплом об образовании (или скан студенческого билета)</li>
            <li>СНИЛС</li>
            <li>ИНН (скрин из Госуслуг/скан документа)</li>
          </ul>
        </section>

        <!-- Как попасть на обучение -->
        <section class="olympic__text mb-5">
          <h1 class="text-dark mb-2">Как попасть на обучение</h1>
          <p class="content_22 mt-2">Просто следуйте следующим шагам:</p>
          <ol class="content_22 mb-2">
            <li><b>Ознакомьтесь</b> с <a href="https://school.exportedu.ru/legal_dpo" target="_blank">текстом публичной оферты</a></li>
            <li><b>Зарегистрируйтесь</b> на сайте Школы экспорта РЭЦ</li>
            <li><b>Подтвердите email</b> — перейдите по ссылке из письма, которое придёт на вашу почту, и войдите в личный кабинет</li>
            <li><b>Заполните заявку</b> и загрузите документы, подтверждающие наличие (или ожидаемое получение) высшего или среднего профессионального образования.</li>
            <li><b>Получите доступ к оплате</b> - на вашу почту придёт ссылка на платформу GetCourse с инструкцией по оплате обучения</li>
            <li><b>Оплатите курс</b> - после оплаты вы сразу получите полный доступ к материалам и сможете начать обучение!</li>
          </ol>
          <div class="mt-4">
            <link-target link="/events/5748" class="mt-1">
              Подать заявку на программу
            </link-target>
          </div>
        </section>


        <!-- Контакты -->
        <section class="olympic__text mb-5">
          <h1 class="text-dark mb-2">Остались вопросы?</h1>
          <p class="content_22 mt-2">Напишите куратору программы — Виктория Стрельникова</p>
          <p class="content_22 mt-2">
            <a href="mailto:v.strelnikova@exportcenter.ru" class="text-dark"><u>v.strelnikova@exportcenter.ru</u></a>
          </p>
          <p class="content_22 mt-2">Мы отвечаем на письма в будние дни с 9:00 до 18:00 по московскому времени.</p>
        </section>

      </div>
    </section-wrapper>
    <page-footer/>
  </div>
</template>

<script>
import SectionWrapper from "@/components/SectionWrapper.vue";
import LinkTarget from "@/components/LinkTarget.vue";
import PageFooter from "@/components/PageFooter.vue";
import Schedule from "@/components/Schedule.vue";

export default {
  name: 'RetrainingLanding',
  components: {
    PageFooter,
    LinkTarget,
    SectionWrapper,
    Schedule,
  },
  data() {
    return {
      programSteps: [
        {
          title: "КОНТЕНТ ОБРАЗОВАТЕЛЬНОГО ИНТЕНСИВА",
          text: `
            <p>Прикладная теория и онлайн-обучение с экспертами</p>
            <ol>
              <li>Введение в экспорт: жизненный цикл экспортного проекта</li>
              <li><b>Эффективный маркетинг для экспортеров</b></li>
              <li>Деловая коммуникация в экспортной деятельности</li>
              <li>Правовое обеспечение экспортного проекта</li>
              <li>Управление финансовыми ресурсами для экспортеров</li>
              <li>Документационное обеспечение экспортной деятельности</li>
              <li>Таможенное оформление экспортных операций</li>
              <li>Логистика в экспортной деятельности</li>
              <li>Возможности онлайн-торговли для экспортеров</li>
              <li>Налоговые аспекты экспортной деятельности</li>
              <li>+ Вебинар: <b>Искусственный интеллект в экспорте</b></li>
            </ol>
            <p><b>Результат:</b> база знаний по жизненному циклу экспортного проекта</p>
            <p class="text-danger"><b>ОНЛАЙН-ИНТЕНСИВ (11 ДНЕЙ)</b></p>
          `
        },
        {
          title: "КОНТЕНТ ПРОЕКТНОЙ ЧАСТИ",
          text: `
            <p>Разработка итогового проекта с поддержкой наставника и практическая работа</p>
            <p><b>Разработка проекта:</b></p>
            <ol>
              <li>Консультации с наставником для проработки итогового экспортного проекта + вебинары для разбора заданий</li>
              <li>Обучение на страновых и тематических вебинарах Российского экспортного центра</li>
            </ol>
            <p><b>5 практических работ:</b></p>
            <ol>
              <li>Выбор рынка</li>
              <li>Анализ выбранного рынка</li>
              <li>Подготовка товара к требованиям рынка</li>
              <li>Реализация и продвижение продукции на зарубежном рынке</li>
              <li>Формирование условий экспортной сделки</li>
            </ol>
            <p><b>Результат:</b> драфт итогового экспортного проекта, расширение знаний в сфере ВЭД</p>
            <p class="text-danger"><b>САМОСТОЯТЕЛЬНАЯ РАБОТА + КОНСУЛЬТАЦИИ</b></p>
          `
        },
        {
          title: "КОНТЕНТ ПРАКТИЧЕСКОЙ ОТРАБОТКИ",
          text: `
            <p class="text-danger"><b>Расширение знаний</b></p>
            <p>Индивидуальная доработка итогового проекта.</p>
            <p>Прикладные знания из акселерационной программы</p>
            <ul>
              <li><b>Модуль 1</b> Подготовка предприятия к выходу на экспорт</li>
              <li><b>Модуль 2</b> Формирование конкурентоспособного предложения</li>
              <li><b>Модуль 3</b> Заключение внешнеторгового контракта</li>
            </ul>
            <p><b>1 итоговый тест</b></p>
            <p>+ Шаблон презентации итогового проекта</p>
            <p class="text-danger"><b>Результат</b> – уточнение и доработка итогового экспортного проекта</p>
            <p class="text-danger"><b>ВИДЕОЗАПИСИ + РАБОТА С ЭКСПЕРТОМ КУРСА</b></p>
          `
        }
      ]
    }
  },
  mounted() {
    this.$parent.init()
  }
}
</script>

<style scoped lang="scss">
.retraining-landing__banner {
  position: absolute;
  top: 2rem;
  right: 2rem;
  z-index: 3;
  
  &__arrow {
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-bottom: 30px solid #ED1B2F;
    margin-bottom: -5px;
  }
  
  &__text {
    background: #ED1B2F;
    color: white;
    padding: 0.8rem 1.5rem;
    font-size: 1.1rem;
    font-weight: 600;
    white-space: nowrap;
  }
}

.retraining-landing__logo {
  position: absolute;
  bottom: 2rem;
  left: 2rem;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 1rem;
  
  &__icon {
    width: 40px;
    height: 40px;
    background: #002E5E;
    border-radius: 50%;
    position: relative;
    
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 20px;
      height: 20px;
      background: white;
      border-radius: 50%;
    }
    
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 12px;
      height: 12px;
      background: #002E5E;
      border-radius: 50%;
    }
  }
  
  &__text {
    font-size: 1.2rem;
    font-weight: 600;
    color: #002E5E;
  }
}

/* Адаптивность для баннера и логотипа */
@media (max-width: 768px) {
  .retraining-landing__banner {
    top: 1rem;
    right: 1rem;
    
    &__text {
      font-size: 1rem;
      padding: 0.6rem 1rem;
    }
  }
  
  .retraining-landing__logo {
    bottom: 1rem;
    left: 1rem;
    
    &__text {
      font-size: 1rem;
    }
  }
}
</style>
